import { TranslationKeys } from './types';

const getTranslations = async (language: string): Promise<TranslationKeys> => {
  const { default: translations } = await import(`../../translations/${language}.json`);
  return translations;
};

export default getTranslations;
